import { render, staticRenderFns } from "./QuestionSingle2.vue?vue&type=template&id=710ae5ff&scoped=true&"
import script from "./QuestionSingle2.vue?vue&type=script&lang=js&"
export * from "./QuestionSingle2.vue?vue&type=script&lang=js&"
import style0 from "./QuestionSingle2.vue?vue&type=style&index=0&id=710ae5ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710ae5ff",
  null
  
)

export default component.exports